import React, { useState } from "react";
import { useApp } from "context";
import { Grid } from "@mui/material";
import { Custom } from "components";

type Props = {
  sx?: any;
  disabled?: boolean;
  items: Custom.ChipProps[];
  onSelect?: (value: any) => void;
};

export const Chip = (props: Props) => {
  const { theme } = useApp();
  const [selected, setSelected] = useState<string | number | null>(null);

  const isSelected = (value: string | number) => selected === value;

  const handleSelect = (value: any) => {
    const newValue = isSelected(value) ? null : value;
    setSelected(newValue);
    props.onSelect && props.onSelect(newValue);
  };

  return (
    <Grid container spacing={theme.margin.xs}>
      {props.items.map((item: Custom.ChipProps, i: number) => (
        <Grid item key={i}>
          <Custom.Chip
            {...item}
            sx={props.sx}
            onClick={handleSelect}
            disabled={props.disabled}
            selected={isSelected(item.id ?? item.label)}
          />
        </Grid>
      ))}
    </Grid>
  );
};
